'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchJSON = exports.getDefaultRequestConfig = exports.resizeImage = exports.formatMoney = exports.range = exports.styleToNumber = exports.serializerQueryParams = exports.createElement = exports.doesStringContainAny = exports.getElements = exports.getElement = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.buildProperties = buildProperties;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};
var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? (0, _from2.default)(items) : items;
};

var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);
  (0, _entries2.default)(options).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    el.setAttribute(key, value);
  });

  return el;
};

var serializerQueryParams = exports.serializerQueryParams = function serializerQueryParams(params) {
  return (0, _entries2.default)(params).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

var styleToNumber = exports.styleToNumber = function styleToNumber(str) {
  return parseInt(str, 10);
};

var range = exports.range = function range(amount) {
  return [].concat((0, _toConsumableArray3.default)(Array(amount).keys()));
};

var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme.moneyFormat;

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var resizeImage = exports.resizeImage = function resizeImage() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      src = _ref5.src,
      size = _ref5.size,
      _ref5$crop = _ref5.crop,
      crop = _ref5$crop === undefined ? null : _ref5$crop,
      _ref5$scale = _ref5.scale,
      scale = _ref5$scale === undefined ? null : _ref5$scale;

  if (size == null) {
    return src;
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '');
  }

  var match = src.match(/\.(jpg|jpeg|pjpg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];
    var scaleString = scale ? '@' + scale + 'x' : '';
    var cropString = crop ? '_crop_' + crop : '';

    return (prefix[0] + '_' + size + cropString + scaleString + suffix).replace(/http(s)?:/, '');
  } else {
    return null;
  }
};

/**
 * This builds up the line item properties for use in Javascript
 *
 * @param formData {FormData} The form we will be traversing to find the properties
 *
 * @returns {Object}
 */
function buildProperties(formData) {
  var propertyKeyValues = [].concat((0, _toConsumableArray3.default)(formData.entries())).filter(function (_ref6) {
    var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
        key = _ref7[0],
        value = _ref7[1];

    return key.includes('properties[') && value !== '';
  });

  function propertyReducer(properties, _ref8) {
    var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];

    var strippedKey = key.replace('properties[', '').slice(0, -1);

    return (0, _assign2.default)({}, properties, (0, _defineProperty3.default)({}, strippedKey, value));
  }

  return propertyKeyValues.reduce(propertyReducer, {});
}

/**
 * This is the default config we will use when using fetch()
 *
 * @returns {Object}
 */
var getDefaultRequestConfig = exports.getDefaultRequestConfig = function getDefaultRequestConfig() {
  return JSON.parse((0, _stringify2.default)({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
};

/**
 * Default fetch boilerplate
 * @param {String} url - The URL we are looking to fetch
 * @param {Object} [config] - .fetch config to override the default
 *
 * @returns {Promise}
 */
var fetchJSON = exports.fetchJSON = function fetchJSON(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, (0, _assign2.default)({}, getDefaultRequestConfig(), config)).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};